// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    EventPageResponse,
    EventPageResponseFromJSON,
    EventPageResponseToJSON,
    MessagePageResponse,
    MessagePageResponseFromJSON,
    MessagePageResponseToJSON,
    MessageRequest,
    MessageRequestFromJSON,
    MessageRequestToJSON,
    MessageResponse,
    MessageResponseFromJSON,
    MessageResponseToJSON,
  } from '../models';

      export interface CreateMessageRequest {
        messageRequest?: MessageRequest;
      }

      export interface GetEventsRequest {
        pageSize?: number;
        page?: number;
      }

      export interface GetMessagesRequest {
        messageType?: string;
        pageSize?: number;
        page?: number;
      }


/**
* no description
*/
export interface MessagesApi {
    /**
      * Create a new message
    */
    createMessage(requestParameters: CreateMessageRequest): Promise<MessageResponse>
    /**
      * Get a page of events for the currently authenticated account
    */
    getEvents(requestParameters: GetEventsRequest): Promise<EventPageResponse>
    /**
      * Get a page of messages for the currently authenticated account
    */
    getMessages(requestParameters: GetMessagesRequest): Promise<MessagePageResponse>
}

  /**
  * no description
  */
  export class MessagesApiImpl extends runtime.BaseAPI implements MessagesApi {

    /**
      * Create a new message
    */
    async createMessageRaw(requestParameters: CreateMessageRequest): Promise<runtime.ApiResponse<MessageResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/messages`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: MessageRequestToJSON(requestParameters.messageRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseFromJSON(jsonValue));
      }

      /**
        * Create a new message
      */
      async createMessage(requestParameters: CreateMessageRequest): Promise<MessageResponse> {
        const response = await this.createMessageRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a page of events for the currently authenticated account
    */
    async getEventsRaw(requestParameters: GetEventsRequest): Promise<runtime.ApiResponse<EventPageResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/account/events`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => EventPageResponseFromJSON(jsonValue));
      }

      /**
        * Get a page of events for the currently authenticated account
      */
      async getEvents(requestParameters: GetEventsRequest): Promise<EventPageResponse> {
        const response = await this.getEventsRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a page of messages for the currently authenticated account
    */
    async getMessagesRaw(requestParameters: GetMessagesRequest): Promise<runtime.ApiResponse<MessagePageResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.messageType !== undefined) {
              queryParameters['messageType'] = requestParameters.messageType;
          }

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/account/messages`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => MessagePageResponseFromJSON(jsonValue));
      }

      /**
        * Get a page of messages for the currently authenticated account
      */
      async getMessages(requestParameters: GetMessagesRequest): Promise<MessagePageResponse> {
        const response = await this.getMessagesRaw(requestParameters);
        return await response.value();
      }

    }
